var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0571 0.0458984C4.87451 0.0458984 4.70643 0.145437 4.61866 0.305557L3.8642 1.68189H2.25178H0.888184C0.612041 1.68189 0.388184 1.90575 0.388184 2.18189C0.388184 2.45803 0.612041 2.68189 0.888184 2.68189H1.75178V11.4539C1.75178 11.7301 1.97564 11.9539 2.25178 11.9539H10.433C10.7091 11.9539 10.933 11.7301 10.933 11.4539V2.68189H11.7965C12.0726 2.68189 12.2965 2.45803 12.2965 2.18189C12.2965 1.90575 12.0726 1.68189 11.7965 1.68189H10.433H8.82234L8.08505 0.309297C7.99792 0.147092 7.8287 0.0458984 7.64457 0.0458984H5.0571ZM4.14443 2.68189C4.14966 2.68206 4.15491 2.68214 4.16017 2.68214H8.52348C8.52874 2.68214 8.53399 2.68206 8.53922 2.68189H9.93298V10.9539H2.75178V2.68189H4.14443ZM7.68721 1.68189L7.34558 1.0459H5.35321L5.00458 1.68189H7.68721ZM5.25137 4.40935C5.52751 4.40935 5.75137 4.63321 5.75137 4.90935V8.45454C5.75137 8.73068 5.52751 8.95454 5.25137 8.95454C4.97522 8.95454 4.75137 8.73068 4.75137 8.45454V4.90935C4.75137 4.63321 4.97522 4.40935 5.25137 4.40935ZM7.93322 4.90935C7.93322 4.63321 7.70937 4.40935 7.43322 4.40935C7.15708 4.40935 6.93322 4.63321 6.93322 4.90935V8.45454C6.93322 8.73068 7.15708 8.95454 7.43322 8.95454C7.70937 8.95454 7.93322 8.73068 7.93322 8.45454V4.90935Z",
    fill: "#D9DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.870808f4c0e345f8740f78ea7fd252cc.svg";
export { ForwardRef as ReactComponent };